import { connect } from 'react-redux';
import { translate } from '../../base/i18n/functions';
import { IconLanguage } from '../../base/icons/svg';
import AbstractButton from '../../base/toolbox/components/AbstractButton';
import { openDialog } from '../../base/dialog/actions';
import LanguageDialog from './LanguageDialog';
/**
 * Component that renders a toolbar button for toggling noise suppression.
 */
class LanguageChangeButton extends AbstractButton {
    constructor() {
        super(...arguments);
        this.accessibilityLabel = 'toolbar.accessibilityLabel.language';
        this.icon = IconLanguage;
        this.label = 'toolbar.language';
        this.tooltip = 'toolbar.language';
    }
    /**
     * Handles clicking / pressing the button.
     *
     * @private
     * @returns {void}
     */
    _handleClick() {
        const { dispatch } = this.props;
        dispatch(openDialog(LanguageDialog));
        //   dispatch(openDialog(SettingsDialog))
    }
}
export default translate(connect()(LanguageChangeButton));
